module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M26.318 16c1.118 0 2.222-.876 2.462-1.954l3.17-12.094C32.194.876 31.486 0 30.368 0H2.024C.906 0 0 .894 0 2s.906 2 2.024 2H4v18c0 1.106.954 2 2.074 2h21.878c1.12 0 2.024-.894 2.024-2s-.906-2-2.024-2H8v-4h18.318zM12 29a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm16 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/cart-1.js
// module id = 1048
// module chunks = 14